"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const images_1 = require("../../assets/images");
const scale_1 = require("../../utils/scale");
const CustomText_1 = __importDefault(require("../text/CustomText"));
const Routes_1 = __importDefault(require("../../navigators/Routes"));
const rootNavigation_1 = require("../../navigators/rootNavigation");
const button_1 = require("../button");
const LinkErrorScreen = () => {
    return (react_1.default.createElement(react_native_1.View, { style: { flex: 1, alignItems: 'center', justifyContent: 'center', paddingHorizontal: (0, scale_1.scale)(32) } },
        react_1.default.createElement(react_native_1.Image, { source: images_1.images.warningImage, style: { height: (0, scale_1.scale)(52), width: (0, scale_1.scale)(52) } }),
        react_1.default.createElement(CustomText_1.default, { weight: "600", style: {
                fontSize: (0, scale_1.moderateScale)(16),
                color: '#292A33',
                lineHeight: (0, scale_1.scale)(24),
                marginTop: (0, scale_1.scale)(16),
                alignItems: 'center',
            } }, "\u304A\u63A2\u3057\u306E\u30DA\u30FC\u30B8\u306F\u5B58\u5728\u3057\u307E\u305B\u3093"),
        react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                fontSize: (0, scale_1.moderateScale)(15),
                lineHeight: (0, scale_1.moderateScale)(23),
                color: '#292A33',
                marginTop: (0, scale_1.scale)(16),
            } }, "\u304A\u63A2\u3057\u306E\u30DA\u30FC\u30B8\u306F\u5B58\u5728\u3057\u306A\u3044\u304B\u3001\u65E2\u306B\u524A\u9664\u3055\u308C\u305F\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002URL\u306B\u9593\u9055\u3044\u306A\u3044\u304B\u518D\u5EA6\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002"),
        react_1.default.createElement(button_1.LinkButton, { title: '\u30DB\u30FC\u30E0\u753B\u9762\u306B\u623B\u308B', onPress: () => { (0, rootNavigation_1.reset)({ index: 0, routeName: Routes_1.default.MAINTABBAR }); }, style: { marginTop: (0, scale_1.scale)(28), alignSelf: 'center' } })));
};
exports.default = LinkErrorScreen;
